import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { warningMessage, confirmLeaveMessage, rejectionMessage, rdtrejectMessage, mandatoryMissingMessage } from "../../../constants";
const STORAGE_KEY = "unsavedChanges";
const DM_STORAGE_KEY = "dmMandatoryFieldsMissing"; //4049



export const UnsavedChangesDialog = ({ visible, onConfirm, onCancel, rejected, taskName }) => (
  <Dialog
        visible={visible}
        className="acp-dialog acpCloseDialogSubContainer headerIcon"
        onHide={onCancel}
        header={<div className="p-dialog-acp">{taskName === "RDT" && rejected ? rdtrejectMessage : rejected ? rejectionMessage : JSON.parse(localStorage.getItem(DM_STORAGE_KEY)) ? mandatoryMissingMessage : warningMessage}</div>}
      >
        <div className="col-sm-12 ">
          <Row className="justify-content-end ">
            <Button   variant="secondary" onClick={onCancel}>
             {(rejected || JSON.parse(localStorage.getItem(DM_STORAGE_KEY)))? "OK" : "No"}
            </Button>
            {(rejected || JSON.parse(localStorage.getItem(DM_STORAGE_KEY))) ? null :
              <Button
                onClick={onConfirm}
                disabled={null}
                className="ms-3"
              >
                Yes
              </Button>
            }
          </Row>
        </div>
      </Dialog>
);

export const useUnsavedChangesWarning = (
  message = confirmLeaveMessage
) => {
  const [isDirty, setIsDirty] = useState(() => {
    // Initialize isDirty state based on local storage
    const storedValue = localStorage.getItem(STORAGE_KEY);
    return storedValue ? JSON.parse(storedValue) : false;
  });

  useEffect(()=>{
    localStorage.setItem("RejectedCase", false);
  },[])

  const handleBeforeUnload = (event) => {
    if (isDirty) {
      event.preventDefault();
      event.returnValue = message;
      markClean();
    }
  };
  useEffect(() => {
    if (isDirty) {
      // window.addEventListener("onpopstate", handleBeforeUnload);
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      if (!isDirty) {
        // window.removeEventListener("onpopstate", handleBeforeUnload);
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    };
  }, [isDirty, message]);
  
  const markDirty = () => {
    setIsDirty(true);
    localStorage.setItem(STORAGE_KEY, true);
  };

  const markClean = () => {
    setIsDirty(false);
    localStorage.setItem(STORAGE_KEY, false);
  };

  const toggleRejected = (value) =>{
    localStorage.setItem("RejectedCase", JSON.stringify(value));
  }

  return { isDirty, markDirty, markClean, toggleRejected };
};
